
    var doc = {"kind":"Document","definitions":[{"kind":"FragmentDefinition","name":{"kind":"Name","value":"EprAggregateRecordFragment"},"typeCondition":{"kind":"NamedType","name":{"kind":"Name","value":"EprAggregateRecord"}},"directives":[],"selectionSet":{"kind":"SelectionSet","selections":[{"kind":"Field","name":{"kind":"Name","value":"id"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"concurrencyVersion"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"uuid"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"periodDescription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"materialDescription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subMaterialDescription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"materialColourDescription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"originDescription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"nation"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"productReference"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"productDescription"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"customerReference"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"headOfficeCustomerReference"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"packagingUse"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"wasteType"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"weightInKilos"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"cost"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"ragStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"subMaterialRagStatus"},"arguments":[],"directives":[]},{"kind":"Field","name":{"kind":"Name","value":"reportName"},"arguments":[],"directives":[]}]}}],"loc":{"start":0,"end":407}};
    doc.loc.source = {"body":"fragment EprAggregateRecordFragment on EprAggregateRecord {\n  id\n  concurrencyVersion\n  uuid\n  periodDescription\n  materialDescription\n  subMaterialDescription\n  materialColourDescription\n  originDescription\n  nation\n  productReference\n  productDescription\n  customerReference\n  headOfficeCustomerReference\n  packagingUse\n  wasteType\n  weightInKilos\n  cost\n  ragStatus\n  subMaterialRagStatus\n  reportName\n}\n","name":"GraphQL request","locationOffset":{"line":1,"column":1}};
  

    var names = {};
    function unique(defs) {
      return defs.filter(
        function(def) {
          if (def.kind !== 'FragmentDefinition') return true;
          var name = def.name.value
          if (names[name]) {
            return false;
          } else {
            names[name] = true;
            return true;
          }
        }
      )
    }
  

    // Collect any fragment/type references from a node, adding them to the refs Set
    function collectFragmentReferences(node, refs) {
      if (node.kind === "FragmentSpread") {
        refs.add(node.name.value);
      } else if (node.kind === "VariableDefinition") {
        var type = node.type;
        if (type.kind === "NamedType") {
          refs.add(type.name.value);
        }
      }

      if (node.selectionSet) {
        node.selectionSet.selections.forEach(function(selection) {
          collectFragmentReferences(selection, refs);
        });
      }

      if (node.variableDefinitions) {
        node.variableDefinitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }

      if (node.definitions) {
        node.definitions.forEach(function(def) {
          collectFragmentReferences(def, refs);
        });
      }
    }

    var definitionRefs = {};
    (function extractReferences() {
      doc.definitions.forEach(function(def) {
        if (def.name) {
          var refs = new Set();
          collectFragmentReferences(def, refs);
          definitionRefs[def.name.value] = refs;
        }
      });
    })();

    function findOperation(doc, name) {
      for (var i = 0; i < doc.definitions.length; i++) {
        var element = doc.definitions[i];
        if (element.name && element.name.value == name) {
          return element;
        }
      }
    }

    function oneQuery(doc, operationName) {
      // Copy the DocumentNode, but clear out the definitions
      var newDoc = {
        kind: doc.kind,
        definitions: [findOperation(doc, operationName)]
      };
      if (doc.hasOwnProperty("loc")) {
        newDoc.loc = doc.loc;
      }

      // Now, for the operation we're running, find any fragments referenced by
      // it or the fragments it references
      var opRefs = definitionRefs[operationName] || new Set();
      var allRefs = new Set();
      var newRefs = new Set();

      // IE 11 doesn't support "new Set(iterable)", so we add the members of opRefs to newRefs one by one
      opRefs.forEach(function(refName) {
        newRefs.add(refName);
      });

      while (newRefs.size > 0) {
        var prevRefs = newRefs;
        newRefs = new Set();

        prevRefs.forEach(function(refName) {
          if (!allRefs.has(refName)) {
            allRefs.add(refName);
            var childRefs = definitionRefs[refName] || new Set();
            childRefs.forEach(function(childRef) {
              newRefs.add(childRef);
            });
          }
        });
      }

      allRefs.forEach(function(refName) {
        var op = findOperation(doc, refName);
        if (op) {
          newDoc.definitions.push(op);
        }
      });

      return newDoc;
    }
    
    module.exports = doc;
    
        module.exports["EprAggregateRecordFragment"] = oneQuery(doc, "EprAggregateRecordFragment");
        
